import TopMenu from '../../components/TopMenu/TopMenu.vue'
import Footer from '../../components/Footer/Footer.vue'

export default {
  data: function() {
    return {
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  computed: {
    section1: function() {
      let title = {
        _1: 'Everything you',
        _2: 'need to know',
        _3: 'about QSDS'
      }
      let description = {
        _1: 'We offer the best all-in sampling and',
        _2: 'delivery service on a 24/7 basis.'
      }

      switch (this.language.value) {
        case 'nl':
          title = {
            _1: 'Alles wat u',
            _2: 'moet weten',
            _3: 'over QSDS'
          }
          description = {
            _1: 'Wij bieden 24/7 de beste',
            _2: 'all-in staalname en transportservice.'
          }
      }

      return {
        title: title,
        description: description
      }
    },
    section2: function() {
      let segment1 = {
        icon: 'fas fa-trophy',
        title: 'Customer success is our focus',
        text: 'We work together with our customers as one team, because we are committed to achieving the best possible service for our customers. We strive to facilitate our client\'s business by helping them deliver the most cost-effective, reliable and time-saving service.'
      }
      let segment2 = {
        icon: 'fas fa-thumbs-up',
        title: 'Striving for excellence',
        text: 'We are professionals, always looking to improve ourselves and always pushing ourselves further. If our customer is dissatisfied with our service, we will strive to improve our processes.'
      }
      let segment3 = {
        icon: 'fas fa-map-signs',
        title: 'Leading the way',
        text: 'Through our extensive years of experience in the field, we saw where the current ways of working could be improved. To help our customers achieve more in less time, we developed a revolutionary platform which can easily be used to keep everyone involved up-to-date, every step of the way. On top of that, we also have the knowledge in house to advise which samples should be taken from any product.'
      }
      let segment4 = {
        icon: 'fas fa-clock',
        title: 'Freeing up precious time',
        text: 'Whenever samples need to be taken or dispatched at a location situated in a different area, a customer doesn\'t want to lose a precious surveyor for several hours. Taking representative samples of a cargo requires product knowledge, skill, care and the right equipment. Our drivers are highly qualified surveyors who are specialized in sampling all kind of cargo.'
      }

      switch (this.language.value) {
        case 'nl':
          segment1 = {
            icon: 'fas fa-trophy',
            title: 'Klantentevredenheid is ons doel',
            text: 'We werken samen met onze klanten als één team, omdat we erop gericht zijn om de best mogelijke diensten aan onze klanten te geven. We streven ernaar om onze klanten vooruit te stuwen in hun business door hen de meest kosten efficiënte, betrouwbare en tijdsbesparende dienst te leveren.'
          }
          segment2 = {
            icon: 'fas fa-thumbs-up',
            title: 'Streven naar uitmuntendheid',
            text: 'Wij zijn professionals, die altijd trachten zichzelf te verbeteren en die zichzelf steeds verder willen drijven. Als onze klant niet tevreden is met onze diensten, zullen we ernaar streven om onze processen te verbeteren.'
          }
          segment3 = {
            icon: 'fas fa-map-signs',
            title: 'Wij nemen het voortouw',
            text: 'Door onze vele jaren van expertise opgebouwd in het werkveld, zagen we waar de huidige manieren van werken verbeterd konden worden. Om onze klanten te helpen bij het bereiken van meer in minder tijd, hebben we een revolutionair portaal ontwikkeld dat automatisch iedereen op de hoogte houdt, doorheen het hele proces. Bovendien hebben we de kennis om te adviseren welke stalen van eender welk product genomen zouden moeten worden.'
          }
          segment4 = {
            icon: 'fas fa-clock',
            title: 'Kostbare tijd vrijmaken',
            text: 'Wanneer er stalen genomen of vervoerd moeten worden naar een locatie in een ander gebied, wil een klant geen kostbare uren van een surveyor verliezen. Representatieve stalen nemen van een cargo vereist productkennis, bekwaamheid, zorg en de juiste uitrusting. Onze chauffeurs zijn hoog gekwalificeerde surveyors die gespecialiseerd zijn in het nemen van stalen van alle type cargos.'
          }
      }

      return {
        segment1: segment1,
        segment2: segment2,
        segment3: segment3,
        segment4: segment4
      }
    },
    section3: function() {
      let title = {
        _1: 'Tap into the power',
        _2: 'of automation'
      }
      let description = 'At QSDS we provide our customers with an end-to-end solution regarding their sampling and transports. Our solution is easy to use for anyone and provides an overview of the current status of a request (for example: our QSDS personnel is on their way, the sample is being transported to the laboratory, etc...).' +
        '<br/><br/>' +
        'All this is accompanied by notifications which can be enabled to keep you, or anyone who needs to be in the loop, up to date on the status via e-mail.'

      switch (this.language.value) {
        case 'nl':
          title = {
            _1: 'Ervaar de kracht',
            _2: 'van automatisatie'
          }
          description = 'Bij QSDS zorgen we voor een complete oplossing voor onze klanten voor wat betreft hun staalnames en transporten. Onze oplossing is makkelijk in gebruik voor iedereen en geeft een overzicht van de huidige status van een aanvraag (bvb: onze QSDS werknemer is op weg naar de klant, het staal word getransporteerd naar het laboratorium, etc...).' +
            '<br/><br/>' +
            'Ons portaal voorziet ook notificaties die ingeschakeld kunnen worden om u, of wie dan ook op de hoogte gehouden moet worden, up-to-date te houden van de huidige status via e-mail.'
      }

      return {
        title: title,
        description: description
      }
    }
  },
  components: {
    'TopMenu': TopMenu,
    'Footer': Footer
  },
  beforeMount() {
    const path = this.$route.path.split('/')
    let language = {
      text: '',
      value: ''
    }

    if (path.length > 0) {
      switch (path[1]) {
        case 'nl':
        case 'en':
          language.value = path[1]
          break
        default:
          /*for (let idx in navigator.languages) {
            const navLanguage = navigator.languages[idx]

            switch (navLanguage) {
              case 'nl':
              case 'en':
                language.value = navLanguage
                break
            }

            if (language.value !== '') {
              break
            }
          }*/

          if (language.value === '') {
            language.value = 'en'
          }
      }
    }

    switch (language.value) {
      case 'nl':
        language.text = 'Nederlands'
        break
      case 'en':
        language.text = 'English'
        break
    }

    this.$store.commit("language", language)
  }
}



// WEBPACK FOOTER //
// ./src/pages/page/about-us/about-us.js